import init from './init';
import update from './update';

export const alertBannerActions = {
  init,
  update
};

export type AlertBannerActions = typeof alertBannerActions;
